@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.unitsWrapper {
    position: relative;
    display: flex;
    justify-content: flex-end;

    .icon {
        position: relative;
        transition: v.$transition;

        &.open {
            transform: rotate(-180deg);
        }
    }
}

.dropdown {
    position: absolute;
    top: 100%;
    right: 16px;
    padding: 4px;
    width: 180px;
    background-color: v.$palette-white;
    border-radius: 6px;
    box-shadow: v.$shadow2;
    transition: v.$transition;
    opacity: 0;
    pointer-events: none;
    z-index: 2;

    &.open {
        opacity: 1;
        pointer-events: all;
    }
}

.list {
    margin: 0;
}

.item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px;
    @include t.text(12px, 20px, 500);
    border-radius: 8px;
    transition: v.$transition;
    cursor: pointer;

    &.active {
        color: v.$palette-orange-2;
        background-color: v.$palette-orange-4;
    }

    @media (pointer: fine) {
        &:hover {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;
        }
    }
}
